import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { UserIdleService } from 'angular-user-idle';
import { LoginService } from '../services/login.service';
import { SharedService } from '../services/shared.service';

declare var $: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit {
  public loading = false;

  captchaCode: any;
  loginObjform = {
    username: localStorage.getItem('loginuser'),
    password: null,
    captcha: null,
    rememberMe: true,
  };
  base64Image: string;
  loginForm: any;
  isDesktop: boolean;
  bannerSrc: string;
  redirectionSrc: string;

  constructor(
    private router: Router,
    private loginService: LoginService,
    private sharedService: SharedService,
    private userIdle: UserIdleService,
    private dialog: MatDialog
  ) {
    this.isDesktop = this.sharedService.isNotMobile();
  }

  ngOnInit() {
    $('.modal-backdrop').remove();
    $('body').removeClass('modal-open');
    this.userIdle.stopWatching();
    this.dialog.closeAll();
    sessionStorage.clear();
    this.createCaptcha();
    this.sharedService.updateTitle('National NCD Program');
    // this.sharedService.preventBackButton();
    if (this.isDesktop) {
      this.getBanner();
    }
  }
  getBanner() {
    this.bannerSrc = 'src/app/assets/images/banner.jpg';
    this.redirectionSrc = 'https://amritmahotsav.nic.in';
    // $('#showBanner').modal('show');
  }
  reloadCaptchaImage() {
    this.createCaptcha();
    this.loginObjform.captcha = null;
  }

  loginFormVal(event) {
    this.loginForm = event;
  }

  isFormValid() {
    if (this.loginForm.form.status === 'INVALID') {
      this.loginForm.form.controls.username.markAsTouched();
      this.loginForm.form.controls.password.markAsTouched();
      this.loginForm.form.controls.captchaInput.markAsTouched();
      return false;
    }
    return true;
  }

  resetPassword() {
    this.router.navigate(['/resetPassword']);
  }

  validateForm() {
    if (this.isFormValid()) {
      this.loading = true;
      const self = this;

      const usernameSalt = this.sharedService.encryptValue(this.loginObjform.username),
        passwordSalt = this.sharedService.encryptValue(usernameSalt + this.loginObjform.password),
        reqObj = {
          grant_type: 'password',
          password: this.sharedService.encryptPwdWithRSA(usernameSalt, passwordSalt),
          username: this.loginObjform.username,
          kaptcha: this.loginObjform.captcha,
          source_type: this.isDesktop ? 0 : 1,
        };

      this.loginService.authenticateUser(reqObj).subscribe(
        (res: any) => {
          const authorityCdss = res.authorities.indexOf('AUTHORITY_CDSS');
          if (this.loginObjform.rememberMe) {
            localStorage.setItem('loginuser', res.user);
          } else {
            localStorage.removeItem('loginuser');
          }
          if (!res.authorities.length || (res.authorities.length === 1 && authorityCdss > -1)) {
            this.router.navigate(['/resetPassword']);
          } else {
            sessionStorage.setItem('jti', res.jti);
            sessionStorage.setItem('access_token', res.access_token);
            sessionStorage.setItem('refresh_token', res.refresh_token);
            sessionStorage.setItem('facilityId', res.facility);
            sessionStorage.setItem('facilityName', res.facilityName);
            sessionStorage.setItem('facilityType', res.facilityType);
            sessionStorage.setItem('parentLocationName', res.parentLocationName);
            sessionStorage.setItem('facilityTypeId', res.facilityTypeId);
            sessionStorage.setItem('loginuser', res.user);
            sessionStorage.setItem('isLocalPortal', res.isLocalPortal);
            sessionStorage.setItem('authorities', res.authorities);
            sessionStorage.setItem('covidType', res.covidType);
            sessionStorage.setItem('cdssType', JSON.stringify(res.authorities.indexOf('AUTHORITY_CDSS') > -1));
            sessionStorage.setItem('stateCode', res.stateCode);
            sessionStorage.setItem('fromLoginPage', 'true');
            // Start watching for user inactivity.
            this.userIdle.startWatching();
            sessionStorage.setItem('APIexpirytime', res['expires_in'])
            // setInterval(function () {
            //   self.sharedService.refreshToken();
            // }, 1080000);

            const islocalHost = window.location.hostname === 'localhost';
            const oldDashboard = res.authorities.indexOf('VIEW_DASHBOARDS') > -1;
            if (this.isDesktop) {
              if (islocalHost) {
                this.updateCookieValues(res);
              }
              // Admin portal
              if (res.authorities.indexOf('SAVE_META_DATA') > -1) {
                if (islocalHost) {
                  window.open('http://localhost:8071/#/adminHome', '_parent');
                } else {
                  this.sharedService.unregisterServiceWorker(window.location.origin + '/portal/admin/');
                }
                // HO Dashboard Portal
              } else if (oldDashboard) {
                if (islocalHost) {
                  window.open('http://localhost:8072/#/dashboardHome', '_parent');
                } else {
                  this.sharedService.unregisterServiceWorker(window.location.origin + '/portal/dashpanel/');
                }
              } else {
                this.router.navigate(['/portal']);
              }
            } else {
              if (res.authorities.indexOf('SAVE_META_DATA') > -1) {
                this.loading = false;
                this.sharedService.showInfoMsg('Sorry! Mobile view is not yet supported for this user & facility.');
                self.loginForm.resetForm();
                this.reloadCaptchaImage();
                localStorage.removeItem('loginuser');
              } else if (oldDashboard) {
                if (islocalHost) {
                  this.updateCookieValues(res);
                  window.open('http://localhost:8072/#/dashboardHome', '_parent');
                } else {
                  this.sharedService.unregisterServiceWorker(window.location.origin + '/portal/dashpanel/');
                }
              } else {
                this.router.navigate(['/portal']);
              }
            }
            if (res.authorities.indexOf('INITIAL_ASSESSMENT_FIRST_ACCESS') > -1) {
              sessionStorage.setItem('nurseUser', 'true');
            }

            if (res.authorities.indexOf('HEALTH_ID') > -1) {
              sessionStorage.setItem('isHealthid', 'true');
            }

            if (res.authorities.indexOf('SUBCENTER_PORTAL_LOGIN') > -1) {
              this.sharedService.scLogin = true;
            }
            if (res.authorities.indexOf('AUTHORITY_EDT') > -1) {
              this.sharedService.choLogin = true;
            }
          }
        },
        (err) => {
          this.loading = false;
          this.loginObjform.password = null;
          this.reloadCaptchaImage();
          localStorage.removeItem('loginuser');
          this.sharedService.showErrorMsg(err);
        }
      );
    } else {
      this.sharedService.scrollToError();
    }
  }

  updateCookieValues(res) {
    this.sharedService.setCookie('jti', res.jti);
    this.sharedService.setCookie('access_token', res.access_token);
    this.sharedService.setCookie('refresh_token', res.refresh_token);
    this.sharedService.setCookie('authorities', res.authorities);
    this.sharedService.setCookie('facilityId', res.facility);
    this.sharedService.setCookie('facilityName', res.facilityName);
    this.sharedService.setCookie('parentLocationName', res.parentLocationName);
    this.sharedService.setCookie('facilityType', res.facilityType);
    this.sharedService.setCookie('facilityTypeId', res.facilityTypeId);
    this.sharedService.setCookie('loginuser', res.user);
    this.sharedService.setCookie('isLocalPortal', res.isLocalPortal);
    this.sharedService.setCookie('covidType', res.covidType);
    this.sharedService.setCookie('stateCode', res.stateCode);
  }

  createCaptcha() {
    const origin = window.location.hostname === 'localhost' ? '' : window.location.origin;
    this.sharedService.getBase64ImageFromURL(origin + '/portal/cphc-auth/kapatcha.jpg').subscribe(
      (base64data) => {
        // this is the image as dataUrl
        this.base64Image = 'data:image/jpg;base64,' + base64data;
      },
      (err) => {
        this.sharedService.showErrorMsg(err);
      }
    );
  }
}
